export default "__VITE_ASSET__CvMcsr2M__"